const p = "wrapper_FSd85", t = "input_CMHRX", r = {
  wrapper: p,
  input: t
};
export {
  r as default,
  t as input,
  p as wrapper
};
//# sourceMappingURL=otpInput.module.scss.js.map
